import React from "react";
import { Navigate } from "react-router-dom";

    function ProtectedRoute({ children }) {
        
        const authed = localStorage.getItem("cwheels_user_isAuthenticated") 
        return JSON.parse(authed) ? children : <Navigate to="/" />;
    }

  export default ProtectedRoute;